import React from "react";
import "./Footer.css";
import { Link, useNavigate, useLocation } from "react-router-dom"; 
import Logo_VehiDoc from "../../../img/Logo_VehiDocOr.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigation = (sectionId, offset = 25) => {
    if (location.pathname === "/") {
      // Si déjà sur la page d'accueil, scroller directement vers la section
      const element = document.getElementById(sectionId);
      if (element) {
        const offsetPosition = element.offsetTop - offset;
  
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    } else {
      // Sinon, rediriger vers la page d'accueil avec l'ancre
      navigate("/#" + sectionId);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <img src={Logo_VehiDoc} alt="Logo VehiDoc" />
          <p>
            Interface pour créer, saisir et organiser vos documents
            administratifs de véhicules neufs et d&apos;occasions.
          </p>
        </div>
        <div className="footer-menu">
          <ul>
            <li>
              <Link
                to="/#hero"
                onClick={(e) => {
                  e.preventDefault(); // Empêche le comportement par défaut
                  handleNavigation("hero", 50); // Appelle handleNavigation pour gérer le défilement
                }}
              >
                À propos
              </Link>
            </li>
            <li>
              <Link
                to="/#features"
                onClick={(e) => {
                  e.preventDefault(); // Empêche le comportement par défaut
                  handleNavigation("features", 25); // Appelle handleNavigation pour gérer le défilement
                }}
              >
                Nos formules
              </Link>
            </li>
            <li>
              <Link 
              to="/#security-documents"
                onClick={(e) => {
                  e.preventDefault(); 
                  handleNavigation("security-documents", 25);
                }}>Contact</Link>
            </li>
            <li>
              <Link to="/login">Mon espace</Link>
            </li>
          </ul>
        </div>
        <div className="footer-legal">
          <ul>
            <li>
              <Link to="/mentions-legales">Mentions légales</Link>
            </li>
            <li>
              <Link to="/politique-confidentialite">Politique de confidentialité</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-realisation">
        <a href="https://sipco.fr/" target="_blank" rel="noopener noreferrer">
          © 2025 - Par SIPCO, à Vitré
        </a>
      </div>
    </footer>
  );
};

export default Footer;